import { Controller } from "@hotwired/stimulus"

// Generic multi-select dropdown: a trigger button shows a summary label and
// opens a popover containing checkboxes. The label updates from checkbox
// state on every change. Used by the agent dashboard's Lead Type filter
// inside the Filters dropdown — mirrors the closed-state summary that the
// React side renders inline.
//
// Label rules — match DashboardsHelper#dashboard_lead_type_summary:
//   0 checked → "All"
//   1 checked → the option's text label
//   N checked → "N selected"
export default class extends Controller {
  static targets = ["wrapper", "trigger", "popover", "label"]

  initialize() {
    this.handleDocClick = this.handleDocClick.bind(this)
    this.handleKey = this.handleKey.bind(this)
  }

  connect() {
    document.addEventListener("click", this.handleDocClick)
    document.addEventListener("keydown", this.handleKey)
  }

  disconnect() {
    document.removeEventListener("click", this.handleDocClick)
    document.removeEventListener("keydown", this.handleKey)
  }

  toggle(event) {
    event?.preventDefault()
    this.isOpen() ? this.close() : this.open()
  }

  open() {
    if (!this.hasPopoverTarget) return
    this.popoverTarget.classList.add("open")
    if (this.hasTriggerTarget) {
      this.triggerTarget.classList.add("active")
      this.triggerTarget.setAttribute("aria-expanded", "true")
    }
  }

  close() {
    if (!this.hasPopoverTarget) return
    this.popoverTarget.classList.remove("open")
    if (this.hasTriggerTarget) {
      this.triggerTarget.classList.remove("active")
      this.triggerTarget.setAttribute("aria-expanded", "false")
    }
  }

  isOpen() {
    return this.hasPopoverTarget && this.popoverTarget.classList.contains("open")
  }

  updateLabel() {
    if (!this.hasLabelTarget || !this.hasPopoverTarget) return
    const checked = Array.from(
      this.popoverTarget.querySelectorAll("input[type='checkbox']:checked")
    )
    if (checked.length === 0) {
      this.labelTarget.textContent = "All"
    } else if (checked.length === 1) {
      const option = checked[0].closest(".gl-multi-select-option")
      const text = option?.querySelector(".gl-multi-select-option-label")?.textContent?.trim()
      this.labelTarget.textContent = text || checked[0].value
    } else {
      this.labelTarget.textContent = `${checked.length} selected`
    }
  }

  handleDocClick(event) {
    if (!this.isOpen()) return
    if (!this.hasWrapperTarget) return
    if (this.wrapperTarget.contains(event.target)) return
    this.close()
  }

  handleKey(event) {
    if (event.key === "Escape" && this.isOpen()) this.close()
  }
}
